import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=953b24c4&scoped=true"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"
import style0 from "./WhatsApp.vue?vue&type=style&index=0&id=953b24c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953b24c4",
  null
  
)

export default component.exports